export default {
  "mainVegetable": "zelenchutsi",
  "mainVegetable/01": "zelenchutsi/patladzhan",
  "mainVegetable/02": "zelenchutsi/asperzhi",
  "mainVegetable/03": "zelenchutsi/avokado",
  "mainVegetable/04": "zelenchutsi/tsveklo",
  "mainVegetable/05": "zelenchutsi/brokoli",
  "mainVegetable/06": "zelenchutsi/morkovi",
  "mainVegetable/07": "zelenchutsi/tselina",
  "mainVegetable/08": "zelenchutsi/gabi",
  "mainVegetable/09": "zelenchutsi/zele",
  "mainVegetable/10": "zelenchutsi/bryukselsko-zele",
  "mainVegetable/11": "zelenchutsi/kitaysko-zele",
  "mainVegetable/12": "zelenchutsi/karfiol",
  "mainVegetable/13": "zelenchutsi/zeleva-salata",
  "mainVegetable/14": "zelenchutsi/krastavitsa",
  "mainVegetable/15": "zelenchutsi/tikvichki",
  "mainVegetable/16": "zelenchutsi/endiviya",
  "mainVegetable/17": "zelenchutsi/spanak",
  "mainVegetable/18": "zelenchutsi/bakla",
  "mainVegetable/19": "zelenchutsi/flagolet-fasul",
  "mainVegetable/20": "zelenchutsi/zelen-plosak-fasul",
  "mainVegetable/21": "zelenchutsi/suh-bob",
  "mainVegetable/22": "zelenchutsi/zelen-bob",
  "mainVegetable/23": "zelenchutsi/leshta",
  "mainVegetable/24": "zelenchutsi/salata-makedoniya",
  "mainVegetable/25": "zelenchutsi/tsarevitsa",
  "mainVegetable/26": "zelenchutsi/salaten-miks-mesklun",
  "mainVegetable/27": "zelenchutsi/ryapa",
  "mainVegetable/28": "zelenchutsi/luk",
  "mainVegetable/29": "zelenchutsi/soya",
  "mainVegetable/30": "zelenchutsi/piper",
  "mainVegetable/31": "zelenchutsi/kartofi-i-kartofi",
  "mainVegetable/32": "zelenchutsi/kalnove-soya",
  "mainVegetable/33": "zelenchutsi/repichki",
  "mainVegetable/34": "zelenchutsi/salata-dabov-list",
  "mainVegetable/35": "zelenchutsi/salata-frize",
  "mainVegetable/36": "zelenchutsi/salata-aysberg",
  "mainVegetable/37": "zelenchutsi/piemontska-salata",
  "mainVegetable/38": "zelenchutsi/orizovi-salati",
  "mainVegetable/39": "zelenchutsi/salata-romano",
  "mainVegetable/40": "zelenchutsi/mladi-filizi",
  "mainVegetable/41": "zelenchutsi/marulya",
  "mainVegetable/42": "zelenchutsi/agneshka-marulya",
  "mainVegetable/43": "zelenchutsi/rukola",
  "mainVegetable/44": "zelenchutsi/salsifi",
  "mainVegetable/45": "zelenchutsi/tabule",
  "mainVegetable/46": "zelenchutsi/domati",
  "mainVegetable/47": "zelenchutsi/maslen-bob",
  "mainVegetable/48": "zelenchutsi/nahut",
  "mainVegetable/49": "zelenchutsi/praz",
  "mainVegetable/50": "zelenchutsi/tikva",
  "mainVegetable/51": "zelenchutsi/cherven-bob",
  "mainVegetable/52": "zelenchutsi/yabalki",
  "mainVegetable/53": "zelenchutsi/kesteni",
  "mainVegetable/54": "zelenchutsi/susheni-slivi",
  "mainVegetable/55": "zelenchutsi/gradinar",
  "mainVegetable/56": "zelenchutsi/cherni-maslini",
  "mainVegetable/57": "zelenchutsi/artishok",
  "mainVegetable/58": "zelenchutsi/cherveni-piperki",
  "mainVegetable/59": "zelenchutsi/plosak-zelen-bob",
  "mainVegetable/60": "zelenchutsi/prolet",
  "mainVegetable/61": "zelenchutsi/ratatui",
  "mainVegetable/62": "zelenchutsi/kus-kus",
  "mainVegetable/63": "zelenchutsi/tadzhin",
  "mainVegetable/64": "zelenchutsi/kari-zelenchutsi",
  "mainVegetable/65": "zelenchutsi/chashki",
  "mainVegetable/66": "zelenchutsi",
  "mainVegetable/67": "zelenchutsi/koralova-leshta",
  "mainVegetable/68": "zelenchutsi/kinoa",
  "mainVegetable/69": "zelenchutsi/spelta",
  "mainVegetable/70": "zelenchutsi/bulgur",
  "mainVegetable/71": "zelenchutsi/cherveno-zele",
  "mainVegetable/72": "zelenchutsi/kadravo-zele",
  "mainVegetable/73": "zelenchutsi/div-kereviz",
  "mainVegetable/74": "zelenchutsi/zarneni-i-semena",
  "mainVegetable/75": "zelenchutsi/bobovi",
  "mainVegetable/76": "zelenchutsi/sladak-kartof",
  "mainVegetable/77": "zelenchutsi/tikvi",
  "mainVegetable/78": "zelenchutsi/testo",
  "mainVegetable/79": "zelenchutsi/bob",
  "mainVegetable/80": "zelenchutsi/grah-s-morkovi",
  "mainVegetable/81": "zelenchutsi/grah",
  "mainVegetable/82": "zelenchutsi/edamame",
  "mainVegetable/83": "zelenchutsi/echemik",
  "mainVegetable/84": "zelenchutsi/salaten-miks",
  "mainVegetable/85": "zelenchutsi/sladka-tsikoriya",
  "mainVegetable/86": "zelenchutsi/agneshka-marulya",
  "mainVegetable/87": "zelenchutsi/beybi-spanak",
  "mainVegetable/88": "zelenchutsi/beybi-zelena-bataviya",
  "mainVegetable/89": "zelenchutsi/mangold",
  "mainVegetable/90": "zelenchutsi/obiknoven-pashtarnak",
  "mainVegetable/91": "zelenchutsi/cheren-oriz-venere",
  "mainVegetable/92": "zelenchutsi/bobov-miks",
  "mainVegetable/93": "zelenchutsi/cheren-bob",
  "mainVegetable/94": "zelenchutsi/zaostreno-zele",
  "mainVegetable/95": "zelenchutsi/byal-fasul",
  "mainVegetable/96": "zelenchutsi/susheni-domati",
  "mainVegetable/97": "zelenchutsi/miks-zelenchutsi",
  "mainVegetable/98": "zelenchutsi/tikva-tsigulka",
  "productRange": "vidove",
  "productRange/4G_BIO": "vidove",
  "productRange/4G_SRP": "vidove",
  "productRange/CAN_A_POEL": "vidove",
  "productRange/CAN_SEC_BI": "vidove",
  "productRange/CAN_SEC_CO": "vidove",
  "productRange/CAN_SEC_CU": "vidove",
  "productRange/CAN_SEC_NA": "vidove",
  "productRange/CAN_VAPEUR": "vidove",
  "productRange/CAN_VEG_SA": "vidove",
  "productRange/CAN_VEG_SR": "vidove",
  "productRange/CLASSICVEG": "vidove",
  "productRange/COLDVEGE": "vidove",
  "productRange/COOKMUSH": "vidove",
  "productRange/CRUDITES": "vidove",
  "productRange/DE_NOS_PRO": "vidove",
  "productRange/DOYMUSHACC": "vidove",
  "productRange/DOYMUSHAPE": "vidove",
  "productRange/DRYVEGE": "vidove",
  "productRange/FROZENVEGE": "vidove",
  "productRange/FRZ_ASTUCE": "vidove",
  "productRange/FRZ_GRATIN": "vidove",
  "productRange/FRZ_KELLO": "vidove",
  "productRange/FRZ_LEG_CO": "vidove",
  "productRange/FRZ_PUREES": "vidove",
  "productRange/FRZ_VEG_BI": "vidove",
  "productRange/FRZ_VEG_SR": "vidove",
  "productRange/INDFROZVEG": "vidove",
  "productRange/JEUNES_POU": "vidove",
  "productRange/LAITUES": "vidove",
  "productRange/LOOP": "vidove",
  "productRange/LUNCH_BOWL": "vidove",
  "productRange/MACHE_BASE": "vidove",
  "productRange/MEL_LAITUE": "vidove",
  "productRange/MUSHNATEMI": "vidove",
  "productRange/MUSHNATENT": "vidove",
  "productRange/MUSHNATEPA": "vidove",
  "productRange/MUSHNATMIN": "vidove",
  "productRange/MUSHROOMS": "vidove",
  "productRange/SUNVEGE": "vidove",
  "productRange/TRAIT_CRUD": "vidove",
  "productRange/TRAIT_TABO": "vidove",
  "productRange/TUS_RECETA": "vidove",
  "productRange/WORLDVEGE": "vidove",
  "productRange/PREPARED_VEG": "vidove",
  "productRange/BEAN_SAUCE": "vidove/bob-v-sos",
  "productRange/BEANS": "vidove/bob",
  "productRange/BIO": "vidove/bio",
  "productRange/BOND_KIDS": "vidove/bonduel-kids",
  "productRange/CAN_BIO": "vidove",
  "productRange/CAN_SEC_PR": "vidove",
  "productRange/CARTA_DELL": "vidove/carta-delle-insalate",
  "productRange/CAN_PETITS": "vidove",
  "productRange/CAN_BOCAL": "vidove",
  "productRange/CEREAL_CAN": "vidove/zarneni-zakuski-drugi",
  "productRange/CEREAL_FRZ": "vidove/zarneni-zakuski-zamrazeni",
  "productRange/CEREALI": "vidove/zarneni-zakuski",
  "productRange/CEREALLEGR": "vidove/Cereallegre",
  "productRange/COCCOLE": "vidove/coccole",
  "productRange/CORN": "vidove/tsarevitsa",
  "productRange/CREATIF": "vidove/Creatif",
  "productRange/FRANCAIS": "vidove/100-frenski",
  "productRange/FRZ_FRY_MI": "vidove",
  "productRange/FRZ_MELANG": "vidove",
  "productRange/FRZ_POELEE": "vidove/zamrazeni-gotovi-miksove",
  "productRange/INSALATE_D": "vidove/Insalate-degli-agricoltori",
  "productRange/INSALATONA": "vidove/Insalatona-piu",
  "productRange/LE_REGIONA": "vidove/Le-regionali",
  "productRange/LEGUMIO": "vidove/Legumio",
  "productRange/MIXES_CORN": "vidove/miksove-s-tsarevitsa",
  "productRange/MONO_VEGE": "vidove/mono-zelenchutsi",
  "productRange/MUSHROOMS  ": "vidove/gabi",
  "productRange/NATURA_IN": "vidove/Natura-in-padella",
  "productRange/OTHER_VEG": "vidove/drugi-zelenchutsi",
  "productRange/PEAS": "vidove/grah",
  "productRange/READY_FROZ": "vidove/gotovi-zamrazeni-hrani",
  "productRange/SOUPS": "vidove/zelenchutsi-za-supa",
  "productRange/SPINACH": "vidove/spanak",
  "productRange/STEAM_CAN": "vidove/konserva-na-para",
  "productRange/STEAM_FRZ": "vidove/na-para-zamrazeno",
  "productRange/STEAM_MIX": "vidove/zamrazeni-zelenchutsi-na-para",
  "productRange/STUZZICHIA": "vidove/Stuzzichiamo",
  "productRange/TOUCHE": "vidove/dobavka",
  "productRange/TRAIT_SAL": "vidove",
  "productRange/TUS_RECETA ": "vidove/tvoite-retsepti",
  "productRange/VEG_TO_FRY": "vidove/zelenchutsi-za-parzhene",
  "productRange/VEGGIE": "vidove/vege-oriz",
  "productRange/FRZ_JUSTEA": "vidove",
  "productRange/SALABIS": "vidove",
  "productRange/BON_SENGAG": "vidove",
  "productRange/CROUSTIS": "vidove",
  "season": "sezoni",
  "season/1": "sezoni/lyato",
  "season/2": "sezoni/esen",
  "season/3": "sezoni/zima",
  "season/4": "sezoni/prolet",
  "season/5": "sezoni",
  "technologie": "tehnologiya",
  "technologie/AC01": "tehnologiya/zapazvam",
  "technologie/AD01": "tehnologiya/zamrazen",
  "technologie/AG01": "tehnologiya/presen",
  "technologie/AT01": "tehnologiya/keytaring",
  "recipeDish": "vid-plato",
  "recipeDish/ACC": "vid-plato/dopalnenie",
  "recipeDish/APE": "vid-plato/aperativ",
  "recipeDish/DES": "vid-plato/desert",
  "recipeDish/ENT": "vid-plato/ordyovar",
  "recipeDish/PLAT": "vid-plato/yastie",
  "recipeDish/SAL": "vid-plato/salata",
  "recipeDish/SNA": "vid-plato/snekbar",
  "recipeDish/PDE": "vid-plato/zakuska",
  "recipeDish/DEJ": "vid-plato/obyad",
  "recipeDish/TRA": "vid-plato/traditsionen",
  "recipeDish/GOU": "vid-plato/gurme",
  "recipeDish/ETH": "vid-plato/etnicheska-prinadlezhnost",
  "recipeDish/FCH": "vid-plato/za-detsa",
  "recipeDish/SOU": "vid-plato/supa",
  "pred-recipeTimingCook-facet": "pechivo",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "pechivo/0-15-minuti",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "pechivo/15-30-minuti",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "pechivo/30-45-minuti",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "pechivo/45-minuti",
  "pred-recipeTimingPreparation-facet": "podgotovka",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "podgotovka/0-15-minuti",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "podgotovka/15-30-minuti",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "podgotovka/30-45-minuti",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "podgotovka/45-minuti",
  "pred-recipeCost-Facet": "byudzhet",
  "pred-recipeCost-Facet/petit": "byudzhet/evtina",
  "pred-recipeCost-Facet/moyen": "byudzhet/sredna",
  "pred-recipeCost-Facet/grand": "byudzhet/visok",
  "recipeDifficulty": "podgotovka",
  "recipeDifficulty/1": "podgotovka/lesna",
  "recipeDifficulty/2": "podgotovka/sredna",
  "recipeDifficulty/3": "podgotovka/izcherpatelen",
  "recipeDishNumber": "gosti",
  "recipeDishNumber/1": "gosti/1",
  "recipeDishNumber/2": "gosti/2",
  "recipeDishNumber/3": "gosti/3",
  "recipeDishNumber/4": "gosti/4",
  "recipeDishNumber/5": "gosti/5",
  "recipeDishNumber/6": "gosti/6",
  "recipeDishNumber/7": "gosti/7",
  "recipeDishNumber/8": "gosti/8",
  "productTheme": "produkti-po-tema",
  "productTheme/ACC": "produkti-po-tema/dopalnenie",
  "productTheme/BEA": "produkti-po-tema/bob",
  "productTheme/BIS": "produkti-po-tema/bob-v-sos",
  "productTheme/BIO": "produkti-po-tema/bio",
  "productTheme/CAN": "produkti-po-tema/konservirana-hrana",
  "productTheme/CER": "produkti-po-tema/zarneni-zakuski",
  "productTheme/CLS": "produkti-po-tema/klasika",
  "productTheme/DLE": "produkti-po-tema/zelenchutsi",
  "productTheme/EDR": "produkti-po-tema/dobavki-za-hrana",
  "productTheme/ENT": "produkti-po-tema/ordyovri",
  "productTheme/FRZ": "produkti-po-tema/syurzhele",
  "productTheme/FSD": "produkti-po-tema/za-salati",
  "productTheme/FSH": "produkti-po-tema/taksi",
  "productTheme/ING": "produkti-po-tema/sastavki-za-moite-retsepti",
  "productTheme/JAR": "produkti-po-tema/zelenchutsi-v-burkan",
  "productTheme/LBW": "produkti-po-tema/portsiya-obyad",
  "productTheme/LDF": "produkti-po-tema/zelenchutsi-na-furna",
  "productTheme/LEG": "produkti-po-tema/Les-legumineuses",
  "productTheme/LGO": "produkti-po-tema/Legumio",
  "productTheme/LGR": "produkti-po-tema/grilovani-zelenchutsi",
  "productTheme/LGS": "produkti-po-tema/zelenchutsi-za-supa",
  "productTheme/MAI": "produkti-po-tema/But",
  "productTheme/MUS": "produkti-po-tema/gabi",
  "productTheme/NEW": "produkti-po-tema/novi-produkti",
  "productTheme/PDH": "produkti-po-tema/suhi-zelenchutsi-kuhnenski-sadove",
  "productTheme/PDL": "produkti-po-tema/koshnitsa-zelenchutsi",
  "productTheme/PHR": "produkti-po-tema/pasta-i-pasta",
  "productTheme/PLP": "produkti-po-tema/plato-osnovno",
  "productTheme/RAL": "produkti-po-tema/oriz-zelenchutsi",
  "productTheme/RDM": "produkti-po-tema/kuhnenski-chinii",
  "productTheme/SAL": "produkti-po-tema/vsichko-za-zaplatata-mi",
  "productTheme/SDB": "produkti-po-tema/salateni-kupi",
  "productTheme/SNK": "produkti-po-tema/mezhdinno-hranene",
  "productTheme/SUP": "produkti-po-tema/supa",
  "productTheme/TEX": "produkti-po-tema/teks-meks",
  "productTheme/VGP": "produkti-po-tema/zelenchutsi-beltachini",
  "recipeTheme": "tematichni-retsepti",
  "recipeTheme/01": "tematichni-retsepti/praznichni-retsepti",
  "recipeTheme/02": "tematichni-retsepti/aperativ",
  "recipeTheme/03": "tematichni-retsepti/salati-i-mezhdinni-hraneniya",
  "recipeTheme/04": "tematichni-retsepti/supi-i-gaspacho",
  "recipeTheme/05": "tematichni-retsepti/kish-payove-i-ogreteni",
  "recipeTheme/06": "tematichni-retsepti/spetsialno-za-detsa",
  "recipeTheme/07": "tematichni-retsepti/deserti",
  "recipeTheme/08": "tematichni-retsepti/vegetariansko",
  "recipeTheme/09": "tematichni-retsepti/dopalneniya",
  "recipeTheme/10": "tematichni-retsepti/chuzhdestranni",
  "recipeTheme/11": "tematichni-retsepti/gyuvech",
  "recipeTheme/12": "tematichni-retsepti/salati-i-barbekyu",
  "recipeTheme/13": "tematichni-retsepti/mezhdinni-hraneniya-i-hrana-za-yadene-s-prasti",
  "recipeTheme/14": "tematichni-retsepti/plato-osnovno",
  "recipeTheme/15": "tematichni-retsepti/deserti-i-testeni-izdeliya",
  "recipeTheme/16": "tematichni-retsepti/ordyovri-i-supi",
  "recipeTheme/17": "tematichni-retsepti/salati",
  "recipeTheme/18": "tematichni-retsepti/kupi",
  "recipeTheme/19": "tematichni-retsepti/supi",
  "recipeTheme/20": "tematichni-retsepti/mezhdinni-hraneniya",
  "recipeTheme/21": "tematichni-retsepti/sos",
  "recipeTheme/22": "tematichni-retsepti/edinichni-yastiya",
  "recipeTheme/23": "tematichni-retsepti/drugi-yastiya",
  "recipeTheme/24": "tematichni-retsepti/yastiya-na-furna",
  "recipeTheme/25": "tematichni-retsepti/meksikansko",
  "recipeTheme/26": "tematichni-retsepti/okolo-sveta",
  "recipeTheme/27": "tematichni-retsepti/den-bez-meso",
  "recipeTheme/28": "tematichni-retsepti/bez-vaglehidrati",
  "recipeTheme/33": "tematichni-retsepti/osnova-ot-leshta",
  "recipeTheme/34": "tematichni-retsepti/osnova-ot-karfiol",
  "recipeTheme/35": "tematichni-retsepti/osnova-ot-kartofi",
  "recipeTheme/36": "tematichni-retsepti/osnova-ot-morkovi",
  "recipeTheme/37": "tematichni-retsepti/osnova-ot-spanak",
  "recipeTheme/38": "tematichni-retsepti/osnova-ot-piper",
  "recipeTheme/39": "tematichni-retsepti/osnova-ot-gabi",
  "recipeTheme/40": "tematichni-retsepti/osnova-ot-plosak-zelen-bob",
  "recipeTheme/41": "tematichni-retsepti/osnova-ot-tsarevitsa",
  "recipeTheme/42": "tematichni-retsepti/osnova-ot-grah",
  "recipeTheme/43": "tematichni-retsepti/osnova-ot-cherven-fasul",
  "recipeTheme/44": "tematichni-retsepti/osnova-ot-bob-flazholet",
  "recipeTheme/45": "tematichni-retsepti/osnova-ot-nahut",
  "recipeTheme/46": "tematichni-retsepti/osnova-ot-brokoli",
  "pred-particularite": "hranitelni-navitsi",
  "pred-particularite/Sans%20conservateur": "hranitelni-navitsi/bez-konservanti",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "hranitelni-navitsi",
  "pred-particularite/Sans%20colorant": "hranitelni-navitsi/bez-otsvetiteli",
  "pred-particularite/Sans%20sucre%20ajout%E9": "hranitelni-navitsi/bez-dobavena-zahar",
  "pred-particularite/Sans%20sel%20ajout%E9": "hranitelni-navitsi/bez-dobavena-sol",
  "pred-particularite/Sans%20additif": "hranitelni-navitsi/bez-dobavki",
  "pred-particularite/": "hranitelni-navitsi/naturalna-sol",
  "pred-particularite/Sans%20lactose": "hranitelni-navitsi/bez-laktoza",
  "pred-particularite/Sans%20gluten": "hranitelni-navitsi/bez-gluten",
  "pred-particularite/V%E9g%E9tarien": "hranitelni-navitsi/vege",
  "pred-particularite/V%E9g%E9talien": "hranitelni-navitsi/vegan",
  "pred-particularite/Sans%20sulfite": "hranitelni-navitsi/bez-sulfiti",
  "pred-particularite/A%20la%20vapeur": "hranitelni-navitsi/na-para",
  "pred-particularite/Sans%20condiment": "hranitelni-navitsi/bez-ovkusiteli",
  "cultureType": "tip-kultura",
  "cultureType/Bio": "tip-kultura/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "tip-kultura/bez-ostatatsi-ot-pestitsidi",
  "cultureType/Sans%20OGM": "tip-kultura/bez-gmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "hranitelni-navitsi/vegan",
  "pred-particularite/recipeVeggie": "hranitelni-navitsi/vege",
  "pred-particularite/recipeGlutenfree": "hranitelni-navitsi/bez-gluten",
  "pred-particularite/recipeLactosefree": "hranitelni-navitsi/bez-laktoza",
  "cultureOrigin": "proizhod-na-kultura",
  "cultureOrigin/31": "proizhod-na-kultura/azerbaydzhan",
  "cultureOrigin/32": "proizhod-na-kultura/arzhentina",
  "cultureOrigin/36": "proizhod-na-kultura/avstraliya",
  "cultureOrigin/40": "proizhod-na-kultura/avstriya",
  "cultureOrigin/51": "proizhod-na-kultura/armeniya",
  "cultureOrigin/56": "proizhod-na-kultura/belgiya",
  "cultureOrigin/68": "proizhod-na-kultura/boliviya",
  "cultureOrigin/70": "proizhod-na-kultura/bosna-i-hertsegovina",
  "cultureOrigin/76": "proizhod-na-kultura/braziliya",
  "cultureOrigin/97": "proizhod-na-kultura/evropeyski-sayuz",
  "cultureOrigin/100": "proizhod-na-kultura/balgariya",
  "cultureOrigin/104": "proizhod-na-kultura/burma",
  "cultureOrigin/120": "proizhod-na-kultura/kamerun",
  "cultureOrigin/124": "proizhod-na-kultura/kanada",
  "cultureOrigin/152": "proizhod-na-kultura/chili",
  "cultureOrigin/156": "proizhod-na-kultura/kitay",
  "cultureOrigin/188": "proizhod-na-kultura/kosta-rika",
  "cultureOrigin/191": "proizhod-na-kultura/harvatska",
  "cultureOrigin/196": "proizhod-na-kultura/kipar",
  "cultureOrigin/203": "proizhod-na-kultura/cheshka-republika",
  "cultureOrigin/208": "proizhod-na-kultura/daniya",
  "cultureOrigin/231": "proizhod-na-kultura/etiopiya",
  "cultureOrigin/233": "proizhod-na-kultura/estoniya",
  "cultureOrigin/246": "proizhod-na-kultura/finlandiya",
  "cultureOrigin/250": "proizhod-na-kultura/frantsiya",
  "cultureOrigin/258": "proizhod-na-kultura/frenska-polineziya",
  "cultureOrigin/276": "proizhod-na-kultura/germaniya",
  "cultureOrigin/300": "proizhod-na-kultura/gartsiya",
  "cultureOrigin/320": "proizhod-na-kultura/gvatemala",
  "cultureOrigin/344": "proizhod-na-kultura/hong-kong",
  "cultureOrigin/348": "proizhod-na-kultura/ungariya",
  "cultureOrigin/352": "proizhod-na-kultura/islandiya",
  "cultureOrigin/356": "proizhod-na-kultura/indiya-i-drugi",
  "cultureOrigin/360": "proizhod-na-kultura/indoneziya",
  "cultureOrigin/372": "proizhod-na-kultura/irlandiya",
  "cultureOrigin/376": "proizhod-na-kultura/izrael",
  "cultureOrigin/380": "proizhod-na-kultura/italiya",
  "cultureOrigin/398": "proizhod-na-kultura/kazahstan",
  "cultureOrigin/404": "proizhod-na-kultura/keniya",
  "cultureOrigin/414": "proizhod-na-kultura/kuveyt",
  "cultureOrigin/417": "proizhod-na-kultura/kirgistan",
  "cultureOrigin/422": "proizhod-na-kultura/livan",
  "cultureOrigin/428": "proizhod-na-kultura/latviya",
  "cultureOrigin/440": "proizhod-na-kultura/litva",
  "cultureOrigin/442": "proizhod-na-kultura/lyuksemburg",
  "cultureOrigin/450": "proizhod-na-kultura/madagaskar",
  "cultureOrigin/470": "proizhod-na-kultura/malta",
  "cultureOrigin/480": "proizhod-na-kultura/mavritaniya",
  "cultureOrigin/484": "proizhod-na-kultura/meksiko",
  "cultureOrigin/498": "proizhod-na-kultura/moldova",
  "cultureOrigin/499": "proizhod-na-kultura/cherna-gora",
  "cultureOrigin/504": "proizhod-na-kultura/maroko",
  "cultureOrigin/528": "proizhod-na-kultura/niderlandiya",
  "cultureOrigin/548": "proizhod-na-kultura/vanuatu",
  "cultureOrigin/578": "proizhod-na-kultura/norvegiya",
  "cultureOrigin/586": "proizhod-na-kultura/pakistan",
  "cultureOrigin/604": "proizhod-na-kultura/peru",
  "cultureOrigin/616": "proizhod-na-kultura/polsha",
  "cultureOrigin/620": "proizhod-na-kultura/portugaliya",
  "cultureOrigin/634": "proizhod-na-kultura/katar",
  "cultureOrigin/642": "proizhod-na-kultura/rumaniya",
  "cultureOrigin/643": "proizhod-na-kultura/rusiya",
  "cultureOrigin/703": "proizhod-na-kultura/slovakiya",
  "cultureOrigin/704": "proizhod-na-kultura/vietnam",
  "cultureOrigin/705": "proizhod-na-kultura/sloveniya",
  "cultureOrigin/724": "proizhod-na-kultura/ispaniya",
  "cultureOrigin/752": "proizhod-na-kultura/shvetsiya",
  "cultureOrigin/756": "proizhod-na-kultura/shveytsariya",
  "cultureOrigin/764": "proizhod-na-kultura/tayland",
  "cultureOrigin/784": "proizhod-na-kultura/obedineni-arabski-emirstva",
  "cultureOrigin/792": "proizhod-na-kultura/turtsiya",
  "cultureOrigin/795": "proizhod-na-kultura/turkmenistan",
  "cultureOrigin/804": "proizhod-na-kultura/ukrayna",
  "cultureOrigin/818": "proizhod-na-kultura/egipet",
  "cultureOrigin/826": "proizhod-na-kultura/obedinenoto-kralstvo",
  "cultureOrigin/834": "proizhod-na-kultura/tanzaniya",
  "cultureOrigin/840": "proizhod-na-kultura/saedinenite-amerikanski-shtati",
  "cultureOrigin/999": "proizhod-na-kultura/iznos",
  "cultureOrigin/NON_EU": "proizhod-na-kultura/izvan-es",
  "cultureOrigin/UE": "proizhod-na-kultura/es",
  "cultureOrigin/XXX": "proizhod-na-kultura/prazno"
};
